import React, { useRef, useCallback } from 'react';
import * as Yup from 'yup';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import { Form } from "@unform/web";
import { TextField } from 'unform-material-ui';
import { DialogContent, Grid } from '@material-ui/core';
import api from 'services/api';
import { useSnackbar } from 'notistack';
import { Scope } from '@unform/core';

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: 'relative',
  },
  headerTitle: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  content: {
    padding: theme.spacing(4),
  },
  title: {
    flex: 1,
    color: "#000",
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function CreateCustomerModal({ onCreate }) {
  const classes = useStyles();
  const formRef = useRef(null);
  const { enqueueSnackbar } = useSnackbar();
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);

  async function handleSubmit(data) {
    try {
      const schema = Yup.object().shape({
        first_name: Yup.string().required('O campo é obrigatório.'),
        last_name: Yup.string().required('O campo é obrigatório.'),
        phone: Yup.string().required('O campo é obrigatório.'),
        email: Yup.string().email('Digite um email válido').required('O campo é obrigatório.'),
        address: Yup.object().shape({
          state: Yup.string().required('O campo é obrigatório.'),
          city: Yup.string().required('O campo é obrigatório.'),
          neighborhood: Yup.string().required('O campo é obrigatório.'),
          street: Yup.string().required('O campo é obrigatório.'),
        }),
      });
      await schema.validate(data, {
        abortEarly: false,
      });
      // Validation passed
      await createCustomer(data);
      
      // reset();
    } catch (err) {
      const validationErrors = {};

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach(error => {
          validationErrors[error.path] = error.message;
        });
        formRef.current.setErrors(validationErrors);
      }
    }
  }

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = useCallback(() => {
    setOpen(false);
    setLoading(false);
    formRef.current.reset();
  }, []);

  const createCustomer = useCallback(async (data) => {
    console.log(data);
    try {
      setLoading(true);
      await api.post('customers', data);

      enqueueSnackbar('Cliente cadastrado com sucesso!', {
        variant: 'success',
      });
      formRef.current.setErrors({});
      handleClose();
      onCreate();
    } catch (err) {
      enqueueSnackbar('Não foi possível carregar os dados. Verifique sua conexão com a internet!', {
        variant: 'error',
      });
      setLoading(false);
    }
  }, [enqueueSnackbar, setLoading, onCreate, handleClose]);


  return (
    <div>
      <Button variant="contained" color="primary" onClick={handleClickOpen}>
        Cadastrar Cliente
      </Button>
      <Dialog maxWidth="lg" fullWidth open={open} onClose={handleClose} TransitionComponent={Transition}>
        <AppBar className={classes.appBar}>
          <Toolbar>
            <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
              <CloseIcon />
            </IconButton>
            <Typography variant="h6" color="inherit" className={classes.headerTitle}>
              CADASTRAR NOVO CLIENTE
            </Typography>
          </Toolbar>
        </AppBar>
        <DialogContent dividers className={classes.content}>
          <Form ref={formRef} onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography variant="h6" color="inherit" className={classes.title}>
                  Dados Pessoais
                </Typography>
              </Grid>
              <Grid item xs={3}>
                <TextField
                  name="first_name"
                  fullWidth
                  variant="outlined"
                  label="Nome"
                  placeholder="Primeiro nome"
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  name="last_name"
                  fullWidth
                  variant="outlined"
                  label="Sobrenome"
                  placeholder="Sobrenome"
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  name="email"
                  fullWidth
                  variant="outlined"
                  label="Endereço de Email"
                  placeholder="example@host.com"
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  name="phone"
                  fullWidth
                  variant="outlined"
                  label="Telefone"
                  placeholder="0000000000"
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <Typography variant="h6" color="inherit" className={classes.title}>
                  Informações de Endereço
                </Typography>
              </Grid>
              <Scope path="address">
                <Grid item xs={3}>
                  <TextField
                    name="state"
                    fullWidth
                    variant="outlined"
                    label="Estado"
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>
                <Grid item xs={3}>
                  <TextField
                    name="city"
                    fullWidth
                    variant="outlined"
                    label="Cidade"
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>
                <Grid item xs={3}>
                  <TextField
                    name="neighborhood"
                    fullWidth
                    variant="outlined"
                    label="Bairro"
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>
                <Grid item xs={3}>
                  <TextField
                    name="street"
                    fullWidth
                    variant="outlined"
                    label="Rua"
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>
                <Grid item xs={2}>
                  <TextField
                    name="number"
                    fullWidth
                    variant="outlined"
                    label="Número"
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    name="reference"
                    fullWidth
                    variant="outlined"
                    label="Complemento"
                    multiline
                    rows={4}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>
              </Scope>
              <Grid item xs={12}>
                <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  type="submit"
                  disabled={loading}
                >
                  Cadastrar Cliente
                </Button>
              </Grid>
            </Grid>
          </Form>
          </DialogContent>
      </Dialog>
    </div>
  );
}
